// Data for the "How to Ask Effective Questions" guide
export const questionGuideData = [
  {
    title: "Be specific about what you're looking for",
    badExample: "Show me campaign data",
    goodExample: "Show me the top 5 campaigns with the highest ROI"
  },
  {
    title: "Include relevant filters",
    description: "(product category, date range, etc.)",
    badExample: "Which lists perform best?",
    goodExample: "Which lists perform best for ANTI-AGING products in terms of P/L per buyer?"
  },
  {
    title: "Specify metrics",
    description: "you want to analyze",
    badExample: "How are our campaigns doing?",
    goodExample: "What's the average conversion rate and ROI across our campaigns?"
  },
  {
    title: "Mention exclusions",
    description: "if needed",
    badExample: "Which segments should I target?",
    goodExample: "Which segments should I target for my new ANTI-AGING product, excluding House File?"
  },
  {
    title: "Ask for comparisons",
    description: "when relevant",
    badExample: "How do web orders perform?",
    goodExample: "How do web orders compare to phone orders in terms of average order value?"
  }
];

export const examplePlanningQuestion = "For a product with category ANTI-AGING, which list and segment combinations would likely produce the highest P/L per buyer based on similar products in our history? (exclude House File)";
